import { useCallback, useMemo } from 'react';
import { useQuery } from '@shared/react';
import { fixSearchQuery } from './fixSearchQuery';

interface Options {
    initialSearch?: string;
    queryName?: string;
}

interface Returned {
    querySearch: string;
    setQuerySearch: (search: string) => void;
}

export function useSearchQuery(options: Options): Returned {
    const { initialSearch = '', queryName } = options;

    const [query, setQuery] = useQuery();

    const setQuerySearch = useCallback(
        (searchString: string) => {
            if (queryName) setQuery(queryName, searchString);
        },
        [setQuery, queryName],
    );

    const fixedSearchQuery = useMemo(
        () =>
            fixSearchQuery({
                initialSearch,
                query,
                queryName,
            }),
        [initialSearch, query, queryName],
    );

    return {
        querySearch: fixedSearchQuery,
        setQuerySearch,
    };
}
